var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 250 200"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FDF2F8",
  fillRule: "evenodd",
  d: "M63 134h91q.774-.002 1.5-.161.726.16 1.5.161h52a7 7 0 1 0 0-14h-6a7 7 0 1 1 0-14h19a7 7 0 1 0 0-14h-22a7 7 0 1 0 0-14h-64a7 7 0 1 0 0-14H79a7 7 0 1 0 0 14H39a7 7 0 1 0 0 14h25a7 7 0 1 1 0 14H24a7 7 0 1 0 0 14h39a7 7 0 1 0 0 14m163 0a7 7 0 1 0 0-14 7 7 0 0 0 0 14",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m69.953 70.518 83.024-13.292a3 3 0 0 1 3.437 2.488l.001.01 8.122 51.832a3 3 0 0 1-2.489 3.427l-83.025 13.291a3 3 0 0 1-3.437-2.488l-.001-.01-8.122-51.832a3 3 0 0 1 2.49-3.426",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#960145",
  strokeLinecap: "round",
  strokeWidth: 3,
  d: "m83.345 127.423-3.183.525c-2.187.36-4.24-1.192-4.587-3.467L68.05 75.039c-.346-2.275 1.145-4.412 3.332-4.773l80.176-13.214c2.187-.36 4.24 1.192 4.587 3.468l.807 5.3m.571 3.756.477 3.133"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeOpacity: 0.2,
  strokeWidth: 3,
  d: "m83.345 127.423-3.183.525c-2.187.36-4.24-1.192-4.587-3.467L68.05 75.039c-.346-2.275 1.145-4.412 3.332-4.773l80.176-13.214c2.187-.36 4.24 1.192 4.587 3.468l.807 5.3m.571 3.756.477 3.133"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#FDF2F8",
  fillRule: "evenodd",
  d: "m73.977 72.792 75.76-11.831a3 3 0 0 1 3.425 2.488l7.36 45.819a3 3 0 0 1-2.486 3.438l-.013.002-75.76 11.831a3 3 0 0 1-3.425-2.488l-7.36-45.82a3 3 0 0 1 2.486-3.437z",
  clipRule: "evenodd"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M170.75 77.25h-78.5a4 4 0 0 0-4 4v48.5a4 4 0 0 0 4 4h78.5a4 4 0 0 0 4-4v-48.5a4 4 0 0 0-4-4"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#960145",
  strokeWidth: 2.5,
  d: "M170.75 77.25h-78.5a4 4 0 0 0-4 4v48.5a4 4 0 0 0 4 4h78.5a4 4 0 0 0 4-4v-48.5a4 4 0 0 0-4-4Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeOpacity: 0.2,
  strokeWidth: 2.5,
  d: "M170.75 77.25h-78.5a4 4 0 0 0-4 4v48.5a4 4 0 0 0 4 4h78.5a4 4 0 0 0 4-4v-48.5a4 4 0 0 0-4-4Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#FDF2F8",
  d: "M173.5 89h-84v14h84z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BE185D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M174.171 89h-65.84m65.84 13h-84.84m35.731 19H96.755m6.534-32h-7.196"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  stroke: "#960145",
  strokeWidth: 3,
  d: "M170.75 77.25h-78.5a4 4 0 0 0-4 4v48.5a4 4 0 0 0 4 4h78.5a4 4 0 0 0 4-4v-48.5a4 4 0 0 0-4-4Z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeOpacity: 0.2,
  strokeWidth: 3,
  d: "M170.75 77.25h-78.5a4 4 0 0 0-4 4v48.5a4 4 0 0 0 4 4h78.5a4 4 0 0 0 4-4v-48.5a4 4 0 0 0-4-4Z"
})));
export default SvgCard;